module.exports = __webpack_public_path__ + "media/Resources/AppIcon-013fc5fe.svg";